<template>
  <!--  main div  -->
  <div class="d-flex flex-column mt-2 justify-content-start" style="height: 100%" id="parent">

    <!--  body div  -->
    <div :class="{'flex-grow-1 d-flex flex-column': true, 'elevation-2': !isLargeAndUp}" style="height: 100%">
      <v-card style="height: 100%;">
        <v-card-title>
          <!--  top div  -->
          <div class="d-flex flex-row flex flex-grow-0 mb-2">
            <h4 class="d-none d-sm-flex">Biodata</h4>
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-tabs v-model="tab" class="d-flex flex flex-column flex-grow-1" style="height: 100%">
          <v-tab key="biodata">Information Update</v-tab>
          <v-tab key="identity">Identity</v-tab>
          <v-spacer></v-spacer>
        <v-btn color="primary" depressed v-if="canDownload" class="my-auto mr-2" @click.stop="download">Download</v-btn>
          <v-tabs-items v-model="tab" class="d-flex flex flex-column flex-grow-1" style="height: 100%">
            <v-divider></v-divider>
            <v-tab-item key="biodata" style="height: 100%">
              <div>
                <div>
                  <div class="d-flex flex-column flex-md-row mt-2 justify-content-start" style="height: 100%;">
                    <div class="mr-4" v-if="isMediumAndUp">
                      <v-card elevation="0" rounded>
                        <v-img height="180" width="180" :src="image"></v-img>
                        <div v-if="image == null || image === undefined || image === ''" class="text-center basic--text">
                          Update image in settings after completing biodata
                        </div>
                      </v-card>
                    </div>
                    <div class="flex-grow-1 ml-md-8" >
                      <v-card-title class="pl-0 mt-0 pt-0">Basic</v-card-title>
                      <v-divider class="mb-2"></v-divider>
                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-md-5 flex-grow-1">
                          <div class="basic--text font-weight-bold">Name</div>
                          <v-text-field outlined dense disabled :value="studentName"></v-text-field>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Email</div>
                          <v-text-field outlined dense disabled :value="studentEmail"></v-text-field>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-md-5 flex-grow-1">
                          <div class="basic--text font-weight-bold">Reg. No.</div>
                          <v-text-field outlined dense disabled :value="studentID"></v-text-field>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">DOB</div>
                          <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              :disabled="information.dob != null"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="userDetails.dob"
                                  readonly
                                  :disabled="information.dob != null"
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  dense
                                  placeholder="DOB Picker"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="userDetails.dob"
                                :active-picker.sync="activePicker"
                                min="1950-01-01"
                                :disabled="information.dob != null"
                                @change="saveDate"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-md-5 flex-grow-1">
                          <div class="basic--text font-weight-bold">Home Town</div>
                          <v-text-field :disabled="information != null && information.homeTown != null" outlined dense v-model="userDetails.homeTown"></v-text-field>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Home Address</div>
                          <v-text-field outlined dense v-model="userDetails.homeAddress"></v-text-field>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-md-5 flex-grow-1">
                          <div class="basic--text font-weight-bold">Country</div>
                          <v-autocomplete :disabled="information != null && information.country != null" :items="countries" v-model="selectedCountry" item-text="name" return-object dense outlined :loading="loadingCountries"></v-autocomplete>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">State</div>
                          <v-autocomplete :disabled="information != null && information.state != null" :items="states" v-model="selectedState" item-text="name" return-object dense outlined :loading="loadingStates"></v-autocomplete>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row">
                        <div :class="{'mr-md-5 flex-grow-1': true, 'w-50': isMediumAndUp}">
                          <div class="basic--text font-weight-bold">LGA/City</div>
                          <v-autocomplete :disabled="information != null && information.lga != null" :items="lgas" item-text="name" item-value="id" v-model="userDetails.lgaId" dense outlined :loading="loadingCountries"></v-autocomplete>
                        </div>
                        <div :class="{'mr-2 flex-grow-1': true, 'w-50': isMediumAndUp}">
                          <div class="basic--text font-weight-bold">Contact Address</div>
                          <v-text-field outlined dense v-model="userDetails.contactAddress"></v-text-field>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row flex-grow-1">
                        <div :class="{'mr-md-5 flex-grow-1': true, 'w-50': isMediumAndUp}">
                          <div class="basic--text font-weight-bold">Place of Birth Address</div>
                          <v-text-field :disabled="information != null && information.placeOfBirth != null" outlined dense v-model="userDetails.placeOfBirth"></v-text-field>
                        </div>
                        <div :class="{'flex-grow-1': true, 'w-50 mr-2': isMediumAndUp}">
                          <div class="basic--text font-weight-bold">Gender</div>
                          <v-select :disabled="information != null && information.gender != null" :items="basicData.genders" v-model="userDetails.genderId" item-text="title" item-value="id" dense outlined></v-select>
                        </div>
                        <div :class="{'flex-grow-1': true, 'w-50 mr-2': isMediumAndUp}">
                          <div class="basic--text font-weight-bold">Tribe</div>
                          <v-select :disabled="information != null && information.tribe != null" :items="tribes" v-model="userDetails.tribeId" item-text="name" item-value="id" dense outlined></v-select>
                        </div>
                      </div>

                      <div class="d-flex flex-column flex-md-row">
                        <div class="flex-grow-1 mr-md-5">
                          <div class="basic--text font-weight-bold">Religion</div>
                          <v-select :items="basicData.religions" item-value="id" item-text="title" :disabled="information != null && information.religion != null" v-model="userDetails.religionId" dense outlined></v-select>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Marital Status</div>
                          <v-select :items="basicData.maritalStatuses" item-value="id" item-text="title" v-model="userDetails.maritalStatusId" dense outlined></v-select>
                        </div>
                      </div>

                      <v-card-title class="pl-0">Health</v-card-title>
                      <v-divider class="mb-2"></v-divider>
                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Blood Group</div>
                          <v-select :items="basicData.bloodGroups" item-value="id" item-text="name" v-model="userDetails.bloodGroupId" dense outlined></v-select>
                        </div>
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Genotype</div>
                          <v-select :items="basicData.genotypes" item-value="id" item-text="name" v-model="userDetails.genotypeId" dense outlined></v-select>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Disablity</div>
                          <v-text-field v-model="userDetails.disability" dense outlined></v-text-field>
                        </div>
                      </div>

                      <v-card-title class="pl-0">Next of Kin</v-card-title>
                      <v-divider class="mb-2"></v-divider>
                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Next of Kin Name</div>
                          <v-text-field v-model="userDetails.nextOfKinName" dense outlined></v-text-field>
                        </div>
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Next of Kin Phone</div>
                          <v-text-field v-model="userDetails.nextOfKinPhone" dense outlined></v-text-field>
                        </div>

                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Next of Kin Address</div>
                          <v-text-field v-model="userDetails.nextOfKinAddress" dense outlined></v-text-field>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Relationship</div>
                          <v-select dense :items="basicData.relationships" item-value="id" item-text="title" outlined v-model="userDetails.nextOfKinRelationshipId"></v-select>
                        </div>
                      </div>

                      <v-card-title class="pl-0">Sponsor/Sport</v-card-title>
                      <v-divider class="mb-2"></v-divider>
                      <div class="d-flex flex-column flex-md-row">
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Sponsor Name</div>
                          <v-text-field v-model="userDetails.sponsorName" dense outlined></v-text-field>
                        </div>
                        <div class="mr-2 flex-grow-1">
                          <div class="basic--text font-weight-bold">Other Sponsor</div>
                          <v-text-field v-model="userDetails.otherSponsorName" dense outlined></v-text-field>
                        </div>
                        <div class="flex-grow-1">
                          <div class="basic--text font-weight-bold">Sport</div>
                          <v-text-field v-model="userDetails.sport" dense outlined></v-text-field>
                        </div>
                      </div>
                      <div class="d-flex flex-row mb-10">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" depressed :loading="loading" @click="save">Update</v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item key="identity" style="height: 100%">
              <div class="pa-4">
                <v-card-title class="pl-0 mt-0 pt-0">National Identity Number (NIN)</v-card-title>
                <v-divider class="mb-4"></v-divider>
                <v-alert type="info" text dense class="mb-4">
                  Enter your 11-digit National Identification Number (NIN). Once saved, this will be linked to your student record.
                </v-alert>
                <div class="d-flex flex-column flex-md-row">
                  <div :class="{'mr-md-5 flex-grow-1': true, 'w-50': isMediumAndUp}">
                    <div class="basic--text font-weight-bold">NIN</div>
                    <v-text-field
                      v-model="nin"
                      outlined
                      dense
                      placeholder="Enter your 11-digit NIN"
                      :rules="ninRules"
                      :disabled="ninSaved"
                      counter="11"
                      maxlength="11"
                    ></v-text-field>
                  </div>
                </div>
                <div class="d-flex flex-row mb-10">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" depressed :loading="savingNin" :disabled="!isNinValid || ninSaved" @click="saveNin">
                    {{ ninSaved ? 'Saved' : 'Update NIN' }}
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        </v-card-text>
      </v-card>


    </div>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import ErrorResolver from "@/shared/ErrorResolver";
import Api from "@/main/api";
import Defaults from "@/shared/Defaults";
import DateUtil from "@/shared/DateUtil";

export default {
  name: "BioData",
  components: {MessageBox, LoadingDialog},
  data: () => ({
    tab: null,
    date: null,
    menu: false,
    activePicker: null,
    loadingCountries: false,
    loadingStates: false,
    selectedCountry: null,
    selectedState: null,
    userDetails: {},
    countries: [],
    states: [],
    lgas: [],
    tribes: [],
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    hasInformation: false,
    information: {},
    hasLoaded: false,
    showBiometricsEnrollment: false,
    biometricCaptured: false,
    image: '',
    nin: '',
    savingNin: false,
    ninSaved: false,
    basicData: {
      titles: [],
      maritalStatuses: [],
      religions: [],
      genders: [],
      relationships: [],
      genotypes: [],
      bloodGroups: [],
    },
  }),

  methods: {
    saveDate (date) {
      this.$refs.menu.save(date)
    },

    init() {
      this.loadBasicData();
      this.loadCountries();
      this.loadTribes();
      if(this.getUser != null){
        this.getInformation()
      }
    },

    loadCountries: function(){
      this.loadingCountries = true;
      Api.nationality.getCountries().then(res => this.countries = res.data)
      .catch(err => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loadingCountries = false)
    },

    fetchStates(country){
      this.loadingStates = true;
      Api.nationality.getStates(country).then(res => {
        this.states = res.data
        if(this.information.state){
          this.selectedState = this.information.state
        }
      })
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loadingStates = false)
    },

    fetchLgas(stateId){
      this.loading = true
      this.lgas = []
      Api.nationality.getLgas(stateId)
          .then(res => this.lgas = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadBasicData(){
      this.loading = true
      Api.basicInformation.getAll().then(res => this.basicData = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    loadTribes(){
      this.loading = true
      Api.nationality.getTribes()
          .then(res => this.tribes = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    save(){
      this.loading = true;
      Api.studentInformation.updateInformation(this.getUser.userId, this.userDetails)
      .then(res => {
        if(res.data != null){
          this.prefileData(res.data)
          this.userDetails.student = null;
          this.userDetails.userTemp = null;
          this.hasInformation = true
          this.message = "Information Updated";
          this.messageType = 'success'
          this.messageShow = true

          // reload
          let f = function(){
            window.location.reload()
          }

          setTimeout(f, 1000)
        }
      }).catch(err => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false)
    },

    prefileData(res){
      if(res.data != null){
        this.information = res.data
        this.hasInformation = res.data.country != null
        this.userDetails.homeTown = res.data.homeTown;
        this.userDetails.homeAddress = res.data.homeAddress;
        this.userDetails.contactAddress = res.data.contactAddress;
        this.userDetails.disability = res.data.disability;
        this.userDetails.placeOfBirth = res.data.placeOfBirth;
        this.userDetails.nextOfKinName = res.data.nextOfKinName;
        this.userDetails.nextOfKinPhone = res.data.nextOfKinPhone
        this.userDetails.nextOfKinAddress = res.data.nextOfKinAddress;
        this.userDetails.sponsorName = res.data.sponsorName
        this.userDetails.otherSponsorName = res.data.otherSponsorName
        this.userDetails.sport = res.data.sport
        this.userDetails.student = null;
        this.userDetails.userTemp = null;
        // dob
        if(res.data.dob != null)
          this.userDetails.dob = DateUtil.toISO(new Date(res.data.dob)).substring(0, 10)
        else
          this.userDetails.dob = new Date(Date.now()).toISOString().substring(0, 10)

        if(res.data.country)
          this.selectedCountry = res.data.country


        if(res.data.state) // countries have been loaded
          this.selectedState = res.data.state;

        if(res.data.tribe != null){
          this.userDetails.tribeId = res.data.tribe.id
        }

        if(res.data.gender != null){
          this.userDetails.genderId = res.data.gender.id
        }

        if(res.data.genotype != null){
          this.userDetails.genotypeId = res.data.genotype.id
        }

        if(res.data.bloodGroup != null){
          this.userDetails.bloodGroupId = res.data.bloodGroup.id
        }

        if(res.data.maritalStatus != null){
          this.userDetails.maritalStatusId = res.data.maritalStatus.id
        }

        if(res.data.nextOfKinRelationship != null){
          this.userDetails.nextOfKinRelationshipId = res.data.nextOfKinRelationship.id
        }

        if(res.data.religion != null){
          this.userDetails.religionId = res.data.religion.id
        }

        if(res.data.country != null){
          this.selectedCountry = res.data.country
        }

        if(res.data.state != null){
          this.selectedState = res.data.state
        }

        if(res.data.lga != null){
          this.userDetails.lgaId = res.data.lga.id
        }

        if(res.data.nin != null && res.data.nin !== ''){
          this.nin = res.data.nin
          this.ninSaved = true
        }
      }
    },

    getInformation(){
      this.loading = true;
      Api.studentInformation.getInformation(this.getUser.userId)
          .then(res => {
            this.prefileData(res)
            // console.log(res.data)
            this.loading = false
          }).catch(err => {
            ErrorResolver.checkErrors(this, err)
            this.loading = false
      })
    },

    saveNin(){
      this.savingNin = true;
      Api.studentInformation.updateNin({
        studentId: this.getUser.userId,
        nin: this.nin,
      }).then(() => {
        this.message = "NIN updated successfully";
        this.messageType = 'success';
        this.messageShow = true;
        this.ninSaved = true;
      }).catch(err => ErrorResolver.checkErrors(this, err))
      .finally(() => this.savingNin = false)
    },

    download(){
      this.loading = true;
      Api.studentInformation.download(this.getUser.userId)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', this.getUser.userId + '-sif.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(err => {
            this.message = "Failed to download content";
            this.messageType = "error";
            this.messageShow = true;
      }).finally(() => this.loading = false)
    },
  },

  computed: {
    ...mapGetters(['getUser', 'getCurrentSession']),

    canDownload: function(){
      return this.getUser != null && this.information != null && this.information.lga != null
        && this.information.religion != null;
    },

    enableEdit: function(){
      return true;
    },

    isLargeAndUp: function(){
      return this.$vuetify.breakpoint.lgAndUp
    },

    studentName: function(){
      return this.getUser != null ? this.getUser.name : ""
    },

    studentEmail: function(){
      return this.getUser != null ? this.getUser.email : ""
    },

    studentID: function(){
      return this.getUser != null ? this.getUser.userId : ""
    },

    user: function(){
      return this.getUser
    },

    isMobile: function(){
      return this.$vuetify.breakpoint.smAndDown
    },

    isMedium: function(){
      return this.$vuetify.breakpoint.mdOnly
    },

    isMediumAndDown: function(){
      return this.$vuetify.breakpoint.mdAndDown
    },


    isMediumAndUp: function(){
      return this.$vuetify.breakpoint.mdAndUp
    },

    ninRules() {
      return [
        v => !!v || 'NIN is required',
        v => /^\d{11}$/.test(v) || 'NIN must be exactly 11 digits',
      ]
    },

    isNinValid() {
      return /^\d{11}$/.test(this.nin)
    },
  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },

    selectedCountry: function(newVal){
      if(newVal != null){
        // fetch state of the country
        this.states = []
        this.fetchStates(newVal.id)
        // if user's state has already been set, dont update it
        if(!this.information.state){
          this.userDetails.stateId = null
        }

        this.userDetails.countryId = newVal.id;
      }
    },

    selectedState: function(newVal){
      if(newVal != null ){
        this.fetchLgas(newVal.id);
        this.userDetails.stateId = newVal.id
        // change lga only if the user's lga is not already provided
        if(!this.information.lga){
          this.userDetails.lgaId = null
        }
      }
    },

    getUser: function(newVal){
      if(newVal != null){
        this.userDetails.name = newVal.name
        this.userDetails.email = newVal.email
        this.userDetails.userId = newVal.userId
        this.image = Defaults.api + '/profile-picture/fetch?user=' +  newVal.userId;

        this.getInformation();
      }
    },

    countries: function(newVal){
      if(this.userDetails.country && newVal != null && this.countries.length > 0){
        let ob = this.countries.filter(e => e.name === this.userDetails.country);
        this.selectedCountry = ob[0]
      }
    }
  },

  created() {
    this.init()
    this.image = Defaults.api + '/profile-picture/fetch?user=' +  this.getUser.userId;
  }
}
</script>

<style scoped>
.w-50{
  width: 50%;
}
</style>
